module.exports = __webpack_public_path__ + "img/temp-contact-us.89388d18.jpg";